import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import RightDoubleArrow from '@mui/icons-material/DoubleArrow'
import { Box, IconButton, styled } from '@mui/material'
import { MouseEventHandler } from 'react'

const LeftDoubleArrow = styled(RightDoubleArrow)(() => ({
  transform: 'rotate(180deg)',
}))

const ArrowBackIosIcon = styled(ArrowForwardIosIcon)(() => ({
  transform: 'rotate(180deg)',
}))

type Handler = MouseEventHandler<HTMLButtonElement>
interface Props {
  onRightClick: Handler
  onAllRightClick: Handler
  onLeftClick: Handler
  onAllLeftClick: Handler
}

const MidController = (props: Props) => {
  const { onRightClick, onAllRightClick, onLeftClick, onAllLeftClick } = props

  return (
    <Box display="flex" flexDirection="column" justifyContent="center">
      <IconButton onClick={onAllRightClick} data-testid="right-double-arrow">
        <RightDoubleArrow />
      </IconButton>

      <IconButton onClick={onRightClick} data-testid="arrow-forward">
        <ArrowForwardIosIcon />
      </IconButton>

      <IconButton onClick={onLeftClick} data-testid="arrow-back">
        <ArrowBackIosIcon />
      </IconButton>

      <IconButton onClick={onAllLeftClick} data-testid="left-double-arrow">
        <LeftDoubleArrow />
      </IconButton>
    </Box>
  )
}

export default MidController
